export const currencySymbolCodes = new Map<string, {CurrencySymbol: string, Description: string}>([
  ['AED', { CurrencySymbol: 'AED', Description: 'UAE Dirham'}],
  ['AFN', { CurrencySymbol: 'AFN', Description: 'Afghani'}],
  ['ALL', { CurrencySymbol: 'ALL', Description: 'Lek'}],
  ['AMD', { CurrencySymbol: 'AMD', Description: 'Armenian Dram'}],
  ['ANG', { CurrencySymbol: 'ANG', Description: 'Netherlands Antillean Guilder'}],
  ['AOA', { CurrencySymbol: 'AOA', Description: 'Kwanza'}],
  ['ARS', { CurrencySymbol: 'ARS', Description: 'Argentine Peso'}],
  ['AUD', { CurrencySymbol: '$',   Description: 'Australian Dollar'}],
  ['AWG', { CurrencySymbol: 'AWG', Description: 'Aruban Guilder'}],
  ['AZN', { CurrencySymbol: 'AZN', Description: 'Azerbaijanian Manat'}],
  ['BAM', { CurrencySymbol: 'BAM', Description: 'Convertible Mark'}],
  ['BBD', { CurrencySymbol: 'BBD', Description: 'Barbados Dollar'}],
  ['BDT', { CurrencySymbol: 'BDT', Description: 'Taka'}],
  ['BGN', { CurrencySymbol: 'BGN', Description: 'Bulgarian Lev'}],
  ['BHD', { CurrencySymbol: 'BHD', Description: 'Bahraini Dinar'}],
  ['BIF', { CurrencySymbol: 'BIF', Description: 'Burundi Franc'}],
  ['BMD', { CurrencySymbol: 'BMD', Description: 'Bermudian Dollar'}],
  ['BND', { CurrencySymbol: 'BND', Description: 'Brunei Dollar'}],
  ['BOB', { CurrencySymbol: 'BOB', Description: 'Boliviano'}],
  ['BOV', { CurrencySymbol: 'BOV', Description: 'Mvdol'}],
  ['BRL', { CurrencySymbol: 'BRL', Description: 'Brazilian Real'}],
  ['BSD', { CurrencySymbol: 'BSD', Description: 'Bahamian Dollar'}],
  ['BTN', { CurrencySymbol: 'BTN', Description: 'Ngultrum'}],
  ['BWP', { CurrencySymbol: 'BWP', Description: 'Pula'}],
  ['BYR', { CurrencySymbol: 'BYR', Description: 'Belarussian Ruble'}],
  ['BZD', { CurrencySymbol: 'BZD', Description: 'Belize Dollar'}],
  ['CAD', { CurrencySymbol: '$',   Description: 'Canadian Dollar'}],
  ['CDF', { CurrencySymbol: 'CDF', Description: 'Congolese Franc'}],
  ['CHE', { CurrencySymbol: 'CHE', Description: 'WIR Euro'}],
  ['CHF', { CurrencySymbol: 'CHF', Description: 'Swiss Franc'}],
  ['CHW', { CurrencySymbol: 'CHW', Description: 'WIR Franc'}],
  ['CLF', { CurrencySymbol: 'CLF', Description: 'Unidades de fomento'}],
  ['CLP', { CurrencySymbol: 'CLP', Description: 'Chilean Peso'}],
  ['CNY', { CurrencySymbol: 'CNY', Description: 'Yuan Renminbi'}],
  ['COP', { CurrencySymbol: 'COP', Description: 'Colombian Peso'}],
  ['COU', { CurrencySymbol: 'COU', Description: 'Unidad de Valor Real'}],
  ['CRC', { CurrencySymbol: 'CRC', Description: 'Costa Rican Colon'}],
  ['CUC', { CurrencySymbol: 'CUC', Description: 'Peso Convertible'}],
  ['CUP', { CurrencySymbol: 'CUP', Description: 'Cuban Peso'}],
  ['CVE', { CurrencySymbol: 'CVE', Description: 'Cape Verde Escudo'}],
  ['CZK', { CurrencySymbol: 'CZK', Description: 'Czech Koruna'}],
  ['DJF', { CurrencySymbol: 'DJF', Description: 'Djibouti Franc'}],
  ['DKK', { CurrencySymbol: 'DKK', Description: 'Danish Krone'}],
  ['DOP', { CurrencySymbol: 'DOP', Description: 'Dominican Peso'}],
  ['DZD', { CurrencySymbol: 'DZD', Description: 'Algerian Dinar'}],
  ['EGP', { CurrencySymbol: 'EGP', Description: 'Egyptian Pound'}],
  ['ERN', { CurrencySymbol: 'ERN', Description: 'Nakfa'}],
  ['ETB', { CurrencySymbol: 'ETB', Description: 'Ethiopian Birr'}],
  ['EUR', { CurrencySymbol: '€',   Description: 'Euro'}],
  ['FJD', { CurrencySymbol: 'FJD', Description: 'Fiji Dollar'}],
  ['FKP', { CurrencySymbol: 'FKP', Description: 'Falkland Islands Pound'}],
  ['GBP', { CurrencySymbol: '£',   Description: 'Pound Sterling'}],
  ['GEL', { CurrencySymbol: 'GEL', Description: 'Lari'}],
  ['GHS', { CurrencySymbol: 'GHS', Description: 'Cedi'}],
  ['GIP', { CurrencySymbol: 'GIP', Description: 'Gibraltar Pound'}],
  ['GMD', { CurrencySymbol: 'GMD', Description: 'Dalasi'}],
  ['GNF', { CurrencySymbol: 'GNF', Description: 'Guinea Franc'}],
  ['GTQ', { CurrencySymbol: 'GTQ', Description: 'Quetzal'}],
  ['GYD', { CurrencySymbol: 'GYD', Description: 'Guyana Dollar'}],
  ['HKD', { CurrencySymbol: 'HKD', Description: 'Hong Kong Dollar'}],
  ['HNL', { CurrencySymbol: 'HNL', Description: 'Lempira'}],
  ['HRK', { CurrencySymbol: 'HRK', Description: 'Croatian Kuna'}],
  ['HTG', { CurrencySymbol: 'HTG', Description: 'Gourde'}],
  ['HUF', { CurrencySymbol: 'HUF', Description: 'Forint'}],
  ['IDR', { CurrencySymbol: 'IDR', Description: 'Rupiah'}],
  ['ILS', { CurrencySymbol: 'ILS', Description: 'New Israeli Sheqel'}],
  ['INR', { CurrencySymbol: 'INR', Description: 'Indian Rupee'}],
  ['IQD', { CurrencySymbol: 'IQD', Description: 'Iraqi Dinar'}],
  ['IRR', { CurrencySymbol: 'IRR', Description: 'Iranian Rial'}],
  ['ISK', { CurrencySymbol: 'ISK', Description: 'Iceland Krona'}],
  ['JMD', { CurrencySymbol: 'JMD', Description: 'Jamaican Dollar'}],
  ['JOD', { CurrencySymbol: 'JOD', Description: 'Jordanian Dinar'}],
  ['JPY', { CurrencySymbol: 'JPY', Description: 'Yen'}],
  ['KES', { CurrencySymbol: 'KES', Description: 'Kenyan Shilling'}],
  ['KGS', { CurrencySymbol: 'KGS', Description: 'Som'}],
  ['KHR', { CurrencySymbol: 'KHR', Description: 'Riel'}],
  ['KMF', { CurrencySymbol: 'KMF', Description: 'Comoro Franc'}],
  ['KPW', { CurrencySymbol: 'KPW', Description: 'North Korean Won'}],
  ['KRW', { CurrencySymbol: 'KRW', Description: 'Won'}],
  ['KWD', { CurrencySymbol: 'KWD', Description: 'Kuwaiti Dinar'}],
  ['KYD', { CurrencySymbol: 'KYD', Description: 'Cayman Islands Dollar'}],
  ['KZT', { CurrencySymbol: 'KZT', Description: 'Tenge'}],
  ['LAK', { CurrencySymbol: 'LAK', Description: 'Kip'}],
  ['LBP', { CurrencySymbol: 'LBP', Description: 'Lebanese Pound'}],
  ['LKR', { CurrencySymbol: 'LKR', Description: 'Sri Lanka Rupee'}],
  ['LRD', { CurrencySymbol: 'LRD', Description: 'Liberian Dollar'}],
  ['LSL', { CurrencySymbol: 'LSL', Description: 'Loti'}],
  ['LTL', { CurrencySymbol: 'LTL', Description: 'Lithuanian Litas'}],
  ['LVL', { CurrencySymbol: 'LVL', Description: 'Latvian Lats'}],
  ['LYD', { CurrencySymbol: 'LYD', Description: 'Libyan Dinar'}],
  ['MAD', { CurrencySymbol: 'MAD', Description: 'Moroccan Dirham'}],
  ['MDL', { CurrencySymbol: 'MDL', Description: 'Moldovan Leu'}],
  ['MGA', { CurrencySymbol: 'MGA', Description: 'Malagasy Ariary'}],
  ['MKD', { CurrencySymbol: 'MKD', Description: 'Denar'}],
  ['MMK', { CurrencySymbol: 'MMK', Description: 'Kyat'}],
  ['MNT', { CurrencySymbol: 'MNT', Description: 'Tugrik'}],
  ['MOP', { CurrencySymbol: 'MOP', Description: 'Pataca'}],
  ['MRO', { CurrencySymbol: 'MRO', Description: 'Ouguiya'}],
  ['MUR', { CurrencySymbol: 'MUR', Description: 'Mauritius Rupee'}],
  ['MVR', { CurrencySymbol: 'MVR', Description: 'Rufiyaa'}],
  ['MWK', { CurrencySymbol: 'MWK', Description: 'Kwacha'}],
  ['MXN', { CurrencySymbol: 'MXN', Description: 'Mexican Peso'}],
  ['MXV', { CurrencySymbol: 'MXV', Description: 'Mexican Unidad de Inversion [UDI]'}],
  ['MYR', { CurrencySymbol: 'MYR', Description: 'Malaysian Ringgit'}],
  ['MZN', { CurrencySymbol: 'MZN', Description: 'Metical'}],
  ['NAD', { CurrencySymbol: 'NAD', Description: 'Namibia Dollar'}],
  ['NGN', { CurrencySymbol: 'NGN', Description: 'Naira'}],
  ['NIO', { CurrencySymbol: 'NIO', Description: 'Cordoba Oro'}],
  ['NOK', { CurrencySymbol: 'NOK', Description: 'Norwegian Krone'}],
  ['NPR', { CurrencySymbol: 'NPR', Description: 'Nepalese Rupee'}],
  ['NZD', { CurrencySymbol: 'NZD', Description: 'New Zealand Dollar'}],
  ['OMR', { CurrencySymbol: 'OMR', Description: 'Rial Omani'}],
  ['PAB', { CurrencySymbol: 'PAB', Description: 'Balboa'}],
  ['PEN', { CurrencySymbol: 'PEN', Description: 'Nuevo Sol'}],
  ['PGK', { CurrencySymbol: 'PGK', Description: 'Kina'}],
  ['PHP', { CurrencySymbol: 'PHP', Description: 'Philippine Peso'}],
  ['PKR', { CurrencySymbol: 'PKR', Description: 'Pakistan Rupee'}],
  ['PLN', { CurrencySymbol: 'PLN', Description: 'Zloty'}],
  ['PYG', { CurrencySymbol: 'PYG', Description: 'Guarani'}],
  ['QAR', { CurrencySymbol: 'QAR', Description: 'Qatari Rial'}],
  ['RON', { CurrencySymbol: 'RON', Description: 'Leu'}],
  ['RSD', { CurrencySymbol: 'RSD', Description: 'Serbian Dinar'}],
  ['RUB', { CurrencySymbol: 'RUB', Description: 'Russian Ruble'}],
  ['RWF', { CurrencySymbol: 'RWF', Description: 'Rwanda Franc'}],
  ['SAR', { CurrencySymbol: 'SAR', Description: 'Saudi Riyal'}],
  ['SBD', { CurrencySymbol: 'SBD', Description: 'Solomon Islands Dollar'}],
  ['SCR', { CurrencySymbol: 'SCR', Description: 'Seychelles Rupee'}],
  ['SDG', { CurrencySymbol: 'SDG', Description: 'Sudanese Pound'}],
  ['SEK', { CurrencySymbol: 'SEK', Description: 'Swedish Krona'}],
  ['SGD', { CurrencySymbol: 'SGD', Description: 'Singapore Dollar'}],
  ['SHP', { CurrencySymbol: 'SHP', Description: 'Saint Helena Pound'}],
  ['SLL', { CurrencySymbol: 'SLL', Description: 'Leone'}],
  ['SOS', { CurrencySymbol: 'SOS', Description: 'Somali Shilling'}],
  ['SRD', { CurrencySymbol: 'SRD', Description: 'Surinam Dollar'}],
  ['STD', { CurrencySymbol: 'STD', Description: 'Dobra'}],
  ['SVC', { CurrencySymbol: 'SVC', Description: 'El Salvador Colon'}],
  ['SYP', { CurrencySymbol: 'SYP', Description: 'Syrian Pound'}],
  ['SZL', { CurrencySymbol: 'SZL', Description: 'Lilangeni'}],
  ['THB', { CurrencySymbol: 'THB', Description: 'Baht'}],
  ['TJS', { CurrencySymbol: 'TJS', Description: 'Somoni'}],
  ['TMT', { CurrencySymbol: 'TMT', Description: 'New Manat'}],
  ['TND', { CurrencySymbol: 'TND', Description: 'Tunisian Dinar'}],
  ['TOP', { CurrencySymbol: 'TOP', Description: "Pa'anga"}],
  ['TRY', { CurrencySymbol: 'TRY', Description: 'Turkish Lira'}],
  ['TTD', { CurrencySymbol: 'TTD', Description: 'Trinidad and Tobago Dollar'}],
  ['TWD', { CurrencySymbol: 'TWD', Description: 'New Taiwan Dollar'}],
  ['TZS', { CurrencySymbol: 'TZS', Description: 'Tanzanian Shilling'}],
  ['UAH', { CurrencySymbol: 'UAH', Description: 'Hryvnia'}],
  ['UGX', { CurrencySymbol: 'UGX', Description: 'Uganda Shilling'}],
  ['USD', { CurrencySymbol: '$',   Description: 'US Dollar'}],
  ['USN', { CurrencySymbol: 'USN', Description: 'US Dollar [Next day]'}],
  ['USS', { CurrencySymbol: 'USS', Description: 'US Dollar [Same day]'}],
  ['UYI', { CurrencySymbol: 'UYI', Description: 'Uruguay Peso en Unidades Indexadas [URUIURUI]'}],
  ['UYU', { CurrencySymbol: 'UYU', Description: 'Peso Uruguayo'}],
  ['UZS', { CurrencySymbol: 'UZS', Description: 'Uzbekistan Sum'}],
  ['VEF', { CurrencySymbol: 'VEF', Description: 'Bolivar Fuerte'}],
  ['VND', { CurrencySymbol: 'VND', Description: 'Dong'}],
  ['VUV', { CurrencySymbol: 'VUV', Description: 'Vatu'}],
  ['WST', { CurrencySymbol: 'WST', Description: 'Tala'}],
  ['XAF', { CurrencySymbol: 'XAF', Description: 'CFA Franc BEAC'}],
  ['XAG', { CurrencySymbol: 'XAG', Description: 'Silver'}],
  ['XAU', { CurrencySymbol: 'XAU', Description: 'Gold'}],
  ['XBA', { CurrencySymbol: 'XBA', Description: 'Bond Markets Unit European Composite Unit [EURCO]'}],
  ['XBB', { CurrencySymbol: 'XBB', Description: 'Bond Markets Unit European Monetary Unit [E.M.U.-6]'}],
  ['XBC', { CurrencySymbol: 'XBC', Description: 'Bond Markets Unit European Unit of Account 9 [E.U.A.-9]'}],
  ['XBD', { CurrencySymbol: 'XBD', Description: 'Bond Markets Unit European Unit of Account 17 [E.U.A.-17]'}],
  ['XCD', { CurrencySymbol: 'XCD', Description: 'East Caribbean Dollar'}],
  ['XDR', { CurrencySymbol: 'XDR', Description: 'SDR [Special Drawing Right]'}],
  ['XFU', { CurrencySymbol: 'XFU', Description: 'UIC-Franc'}],
  ['XOF', { CurrencySymbol: 'XOF', Description: 'CFA Franc BCEAO'}],
  ['XPD', { CurrencySymbol: 'XPD', Description: 'Palladium'}],
  ['XPF', { CurrencySymbol: 'XPF', Description: 'CFP Franc'}],
  ['XPT', { CurrencySymbol: 'XPT', Description: 'Platinum'}],
  ['XSU', { CurrencySymbol: 'XSU', Description: 'Sucre'}],
  ['XTS', { CurrencySymbol: 'XTS', Description: 'Codes specifically reserved for testing purposes'}],
  ['YER', { CurrencySymbol: 'YER', Description: 'Yemeni Rial'}],
  ['ZAR', { CurrencySymbol: 'R',   Description: 'South African Rand'}],
  ['ZMK', { CurrencySymbol: 'ZMK', Description: 'Zambian Kwacha'}],
  ['ZWL', { CurrencySymbol: 'ZWL', Description: 'Zimbabwe Dollar'}],
  ['CYP', { CurrencySymbol: 'CYP', Description: 'Cypriot Pound'}],
]);
